
class Tag {
	constructor(type, content='') {
		this.type = type;
		this.content = content;
	}
}

module.exports= Tag;